import _Object$assign from "babel-runtime/core-js/object/assign";
import _regeneratorRuntime from "babel-runtime/regenerator";
import _Promise from "babel-runtime/core-js/promise";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";


import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";
import fxcEncrypt from "@/tools/libs/fxcEncrypt";
import des from "@/tools/libs/standard-des";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";
var SAVE_PATH2 = "";

var checkPassword = function checkPassword(_this, opts) {
  var busiInfo = _this.$storage.getJsonSession(_this.$definecfg.BUSI_INFO);
  var customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO);
  var param = {
    CUST_CODE: customerInfo.CUST_CODE,
    OPEN_FLAG: "0",
    USER_ROLE: "1",
    AUTH_TYPE: "0",
    USE_SCOPE: opts.USE_SCOPE,
    AUTH_DATA: opts.NEW_AUTH_DATA,
    ID_CODE: opts.isBsb && _.get(busiInfo, "BIZ_DATA.BSB_INFO.BSB_ID_CODE", "") || customerInfo.ID_CODE || _.get(busiInfo, "BIZ_DATA.KEY_INFO.NEW_ID_CODE", "") || "",
    BIRTHDAY: _.get(busiInfo, "BIZ_DATA.BASE_INFO.BIRTHDAY", "") || "",
    MOBILE_TEL: _.get(busiInfo, "BIZ_DATA.CONTACT_INFO.MOBILE_TEL", ""),
    TEL: busiInfo && busiInfo.TEL || "",
    OFFICE_TEL: _.get(busiInfo, "BIZ_DATA.CONTACT_INFO.OFFICE_TEL", "")
  };
  return _this.$syscfg.K_Request("QS200090", param).then(function (res) {
    if (res.Code == "0") {
      return true;
    } else {
      return false;
    }
  }).catch(function (err) {
    consoleError("checkPassword\u9519\u8BEF - " + param.ID_CODE, err);
  });
};
var validPassword = function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this, USE_SCOPE, pwd, pwd2) {
    var customerInfo, reqArr, loadingText;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO), reqArr = [];

            if (customerInfo.CUST_CODE) {
              _context.next = 6;
              break;
            }

            _this.alert("未生成客户代码！");
            pwd.DEFAULT_VALUE = "";
            pwd2.DEFAULT_VALUE = "";
            return _context.abrupt("return", false);

          case 6:
            _context.t0 = reqArr;
            _context.t1 = checkPassword;
            _context.t2 = _this;
            _context.t3 = USE_SCOPE;
            _context.next = 12;
            return fxcEncrypt.encrypt(pwd.DEFAULT_VALUE);

          case 12:
            _context.t4 = _context.sent;
            _context.t5 = {
              USE_SCOPE: _context.t3,
              NEW_AUTH_DATA: _context.t4
            };
            _context.t6 = (0, _context.t1)(_context.t2, _context.t5);

            _context.t0.push.call(_context.t0, _context.t6);

            if (!(_this.userType === "2")) {
              _context.next = 27;
              break;
            }

            _context.t7 = reqArr;
            _context.t8 = checkPassword;
            _context.t9 = _this;
            _context.t10 = USE_SCOPE;
            _context.next = 23;
            return fxcEncrypt.encrypt(pwd.DEFAULT_VALUE);

          case 23:
            _context.t11 = _context.sent;
            _context.t12 = {
              USE_SCOPE: _context.t10,
              NEW_AUTH_DATA: _context.t11,
              isBsb: true
            };
            _context.t13 = (0, _context.t8)(_context.t9, _context.t12);

            _context.t7.push.call(_context.t7, _context.t13);

          case 27:
            _this.loading = true;
            loadingText = _this.loadingText;

            _this.loadingText = "正在进行弱密校验！";
            return _context.abrupt("return", _Promise.all(reqArr).then(function (res) {
              _this.loading = false;
              _this.loadingText = loadingText;
              var flag = res[0] && (reqArr.length > 1 ? res[1] : true);
              pwd2.FIELD_REQUIRED = !!flag ? "1" : "0";
              !flag && _this.$set(pwd, "DEFAULT_VALUE", "") && _this.$set(pwd, "FIELD_LAST_CHOOSE_VALUE", "") && console.error("密码不满足认证策略的弱密控制！");
            }).catch(function (err) {
              consoleError("validPassword错误", err);
              _this.loading = false;
              _this.loadingText = loadingText;
            }));

          case 31:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function validPassword(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

var backfillHistoryData = function backfillHistoryData(_this) {
  var passwordInfo = _.cloneDeepGet(_this.historyData, SAVE_PATH);
  var passwordInfo2 = _.cloneDeepGet(_this.historyData, SAVE_PATH2);
  if (!_.isEmpty(passwordInfo)) {
    var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
    try {
      if (passwordInfo.IS_TRD_RSA == "1" && passwordInfo.IS_CUACCT_RSA == "1") {
        if (passwordInfo.TRD_PWD) {
          _this.$set(fields.TRD_PWD, "hasRsaPwd", true);
          _this.$set(fields.TRD_PWD, "IS_SHOW_BUTTON", true);
          _this.$set(fields.CONFIRM_TRD_PWD, "hasRsaPwd", true);
        }
        if (passwordInfo.CUACCT_PWD) {
          _this.$set(fields.CUACCT_PWD, "hasRsaPwd", true);
          _this.$set(fields.CUACCT_PWD, "IS_SHOW_BUTTON", true);
          _this.$set(fields.CONFIRM_CUACCT_PWD, "hasRsaPwd", true);
        }
      } else {
        if (passwordInfo.TRD_PWD && passwordInfo.IS_TRD_RSA != "1") {
          passwordInfo.TRD_PWD = passwordInfo.TRD_PWD && des.decrypt(passwordInfo.TRD_PWD, _.get(_this.historyData, "BIZ_DATA.NEW_CUST_CODE")) || "";
        }
        if (passwordInfo.CUACCT_PWD && passwordInfo.IS_CUACCT_RSA != "1") {
          passwordInfo.CUACCT_PWD = passwordInfo.CUACCT_PWD && des.decrypt(passwordInfo.CUACCT_PWD, _.get(_this.historyData, "BIZ_DATA.NEW_CUST_CODE")) || "";
        }
      }

      passwordInfo.CONFIRM_TRD_PWD = passwordInfo.TRD_PWD;
      passwordInfo.CONFIRM_CUACCT_PWD = passwordInfo.CUACCT_PWD;
      _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], passwordInfo);
    } catch (e) {
      consoleError("密码解析失败，请重新设置密码");
      alert("密码解析错误！");
    }
  }
  if (!_.isEmpty(passwordInfo2)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], passwordInfo2);
  }
};

var initFieldConfig = function initFieldConfig(_this) {
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  _.set(fields, "IS_SAME_PWD.FIELD_TYPE", "radio");
  _.set(fields, "IS_SAME_PWD.isLongItem", true);
};

var setFeildData = function setFeildData(fieldData, fieldAction, val, filterArr) {
  _.each(fieldData, function (item) {
    if (filterArr.indexOf(item.FIELD_ID) == -1) {
      item[fieldAction] = val;
    };
  });
};
var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
    SAVE_PATH2 = params.savePath2;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {
    initFieldConfig(_this);
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
  },

  beforeSave: function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_this, params) {
      var passwordInfo, oldPasswordInfo, oldPasswordInfo2, IS_SAME_PWD, fields, oldTmpData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              passwordInfo = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH, SAVE_PATH2]);
              oldPasswordInfo = _.get(params, "" + SAVE_PATH);
              ;
              oldPasswordInfo2 = _.get(params, "" + SAVE_PATH2);
              ;
              IS_SAME_PWD = passwordInfo.IS_SAME_PWD;

              delete passwordInfo["IS_SAME_PWD"];
              fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
              oldTmpData = _.cloneDeepGet(_this.historyData, SAVE_PATH);

              passwordInfo.IS_TRD_RSA = "1";
              passwordInfo.IS_CUACCT_RSA = "1";

              if (!fields.CUACCT_PWD.hasRsaPwd) {
                _context2.next = 16;
                break;
              }

              passwordInfo.CUACCT_PWD = oldTmpData.CUACCT_PWD;
              passwordInfo.CONFIRM_CUACCT_PWD = oldTmpData.CUACCT_PWD;
              _context2.next = 21;
              break;

            case 16:
              _context2.next = 18;
              return fxcEncrypt.encrypt(passwordInfo.CUACCT_PWD);

            case 18:
              passwordInfo.CUACCT_PWD = _context2.sent;

              passwordInfo.CONFIRM_CUACCT_PWD = passwordInfo.CUACCT_PWD;
              passwordInfo.IS_CUACCT_RSA = "1";

            case 21:
              if (!fields.TRD_PWD.hasRsaPwd) {
                _context2.next = 26;
                break;
              }

              passwordInfo.TRD_PWD = oldTmpData.TRD_PWD;
              passwordInfo.CONFIRM_TRD_PWD = oldTmpData.TRD_PWD;
              _context2.next = 31;
              break;

            case 26:
              _context2.next = 28;
              return fxcEncrypt.encrypt(passwordInfo.TRD_PWD);

            case 28:
              passwordInfo.TRD_PWD = _context2.sent;

              passwordInfo.CONFIRM_TRD_PWD = passwordInfo.TRD_PWD;
              passwordInfo.IS_TRD_RSA = "1";

            case 31:
              if (IS_SAME_PWD == "1") {
                passwordInfo.CUACCT_PWD = _.cloneDeep(passwordInfo.TRD_PWD);
                passwordInfo.CONFIRM_CUACCT_PWD = _.cloneDeep(passwordInfo.TRD_PWD);
                passwordInfo.IS_CUACCT_RSA = _.cloneDeep(passwordInfo.IS_TRD_RSA);
              }

              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH], passwordInfo);
              _.set(params, SAVE_PATH, _Object$assign({}, oldPasswordInfo, passwordInfo));
              _.set(params, SAVE_PATH2, _Object$assign({}, oldPasswordInfo2, { IS_SAME_PWD: IS_SAME_PWD }));

            case 35:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function beforeSave(_x6, _x7) {
      return _ref2.apply(this, arguments);
    }

    return beforeSave;
  }(),
  validate: function () {
    var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(_this) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function validate(_x8) {
      return _ref3.apply(this, arguments);
    }

    return validate;
  }(),

  pageActivated: function pageActivated(_this, groupId) {},
  afterSave: function afterSave(_this, newData) {},
  beforeSkipBiz: function beforeSkipBiz(_this) {},

  CHECK_CONFIRM_TRD_PWD: function CHECK_CONFIRM_TRD_PWD(_this, field, fieldData) {
    if (field.DEFAULT_VALUE !== fieldData.TRD_PWD.DEFAULT_VALUE) {
      _this.$blMethod.changeFieldError(field, false, "交易确认密码与密码不一致");
      alert("确认密码与交易密码不一致");
    }
  },

  CHECK_CONFIRM_CUACCT_PWD: function CHECK_CONFIRM_CUACCT_PWD(_this, field, fieldData) {
    if (field.DEFAULT_VALUE !== fieldData.CUACCT_PWD.DEFAULT_VALUE) {
      _this.$blMethod.changeFieldError(field, false, "确认密码与密码不一致");
      alert("确认密码与资金密码不一致");
    }
  },
  "CHECK_TRD_PWD": function CHECK_TRD_PWD(_this, field, fieldData) {
    if (field.hasRsaPwd) {
      return;
    }
    if (field.DEFAULT_VALUE !== "" && !_this.isRunFieldRules) {
      fieldData.CONFIRM_TRD_PWD.DEFAULT_VALUE = "";
      validPassword(_this, "0", field, fieldData.CONFIRM_TRD_PWD);
    }
  },
  "CHECK_CUACCT_PWD": function CHECK_CUACCT_PWD(_this, field, fieldData) {
    if (field.hasRsaPwd) {
      return;
    }
    if (field.DEFAULT_VALUE !== "" && !_this.isRunFieldRules) {
      fieldData.CONFIRM_CUACCT_PWD.DEFAULT_VALUE = "";
      validPassword(_this, "1", field, fieldData.CONFIRM_CUACCT_PWD);
    }
  },

  "CHECK_TRD_PWD__CLICK": function CHECK_TRD_PWD__CLICK(_this, field, fieldData) {
    fieldData.CONFIRM_TRD_PWD.hasRsaPwd = false;
    fieldData.CONFIRM_TRD_PWD.DEFAULT_VALUE = "";
  },
  "CHECK_CUACCT_PWD__CLICK": function CHECK_CUACCT_PWD__CLICK(_this, field, fieldData) {
    fieldData.CONFIRM_CUACCT_PWD.hasRsaPwd = false;
    fieldData.CONFIRM_CUACCT_PWD.DEFAULT_VALUE = "";
  },
  "CHECK_IS_SAME_PWD": function CHECK_IS_SAME_PWD(_this, field, fields, module) {
    if (field.DEFAULT_VALUE == "1") {
      setFeildData(fields, "FIELD_CONTROL", "1", ["IS_SAME_PWD", "TRD_PWD", "CONFIRM_TRD_PWD"]);
      fields.CUACCT_PWD.DEFAULT_VALUE = _this.groupDatas.PASSWORD_INFO.PASSWORD_MODULE[0].FIELDS.TRD_PWD.DEFAULT_VALUE;
      fields.CONFIRM_CUACCT_PWD.DEFAULT_VALUE = _this.groupDatas.PASSWORD_INFO.PASSWORD_MODULE[0].FIELDS.CONFIRM_TRD_PWD.DEFAULT_VALUE;
    } else {
      setFeildData(fields, "FIELD_CONTROL", "0", []);
    }
  }
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS420/bizPassword/bizPasswordInfoNode.js
// module id = 168
// module chunks = 2